/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  ApprovalApplicationList,
  ErrorInfo,
  GetApprovalApplicationsParams,
  ApprovalApplicationDetail,
  BinaryFile,
  ApprovalApplicationAdd,
  GetApprovalUsers200,
  GetApprovalUsersParams,
  ApprovalApplicationUpdate
} from '.././model'


/**
 * 指定された制作管理IDに紐づく承認申請一覧取得を取得する。

 * @summary 承認申請一覧取得
 */
export const getApprovalApplications = (
    productionId: number,
    params?: GetApprovalApplicationsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ApprovalApplicationList>> => {
    return axios.get(
      `/approvalApplications/${productionId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetApprovalApplicationsQueryKey = (productionId: number,
    params?: GetApprovalApplicationsParams,) => [`/approvalApplications/${productionId}`, ...(params ? [params]: [])];

    
export type GetApprovalApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovalApplications>>>
export type GetApprovalApplicationsQueryError = AxiosError<ErrorInfo>

export const useGetApprovalApplications = <TData = Awaited<ReturnType<typeof getApprovalApplications>>, TError = AxiosError<ErrorInfo>>(
 productionId: number,
    params?: GetApprovalApplicationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApprovalApplications>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApprovalApplicationsQueryKey(productionId,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovalApplications>>> = ({ signal }) => getApprovalApplications(productionId,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getApprovalApplications>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 承認申請詳細データを取得する。

 * @summary 承認申請一件取得
 */
export const getApprovalApplicationDetail = (
    approvalApplicationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ApprovalApplicationDetail>> => {
    return axios.get(
      `/approvalApplications/detail/${approvalApplicationId}`,options
    );
  }


export const getGetApprovalApplicationDetailQueryKey = (approvalApplicationId: number,) => [`/approvalApplications/detail/${approvalApplicationId}`];

    
export type GetApprovalApplicationDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovalApplicationDetail>>>
export type GetApprovalApplicationDetailQueryError = AxiosError<ErrorInfo>

export const useGetApprovalApplicationDetail = <TData = Awaited<ReturnType<typeof getApprovalApplicationDetail>>, TError = AxiosError<ErrorInfo>>(
 approvalApplicationId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApprovalApplicationDetail>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApprovalApplicationDetailQueryKey(approvalApplicationId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovalApplicationDetail>>> = ({ signal }) => getApprovalApplicationDetail(approvalApplicationId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getApprovalApplicationDetail>>, TError, TData>(queryKey, queryFn, {enabled: !!(approvalApplicationId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 承認申請添付ファイルを取得する。

 * @summary 承認申請添付ファイル取得
 */
export const getApprovalApplicationAttachedFile = (
    fileId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.get(
      `/approvalApplications/attachedFile/${fileId}`,options
    );
  }


export const getGetApprovalApplicationAttachedFileQueryKey = (fileId: number,) => [`/approvalApplications/attachedFile/${fileId}`];

    
export type GetApprovalApplicationAttachedFileQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovalApplicationAttachedFile>>>
export type GetApprovalApplicationAttachedFileQueryError = AxiosError<ErrorInfo>

export const useGetApprovalApplicationAttachedFile = <TData = Awaited<ReturnType<typeof getApprovalApplicationAttachedFile>>, TError = AxiosError<ErrorInfo>>(
 fileId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApprovalApplicationAttachedFile>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApprovalApplicationAttachedFileQueryKey(fileId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovalApplicationAttachedFile>>> = ({ signal }) => getApprovalApplicationAttachedFile(fileId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getApprovalApplicationAttachedFile>>, TError, TData>(queryKey, queryFn, {enabled: !!(fileId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 指定された制作管理IDに紐づく承認申請を新規追加する。

 * @summary 承認申請新規追加
 */
export const postApprovalApplicationAdd = (
    productionId: number,
    approvalApplicationAdd: ApprovalApplicationAdd, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ApprovalApplicationDetail>> => {const formData = new FormData();
formData.append('action', approvalApplicationAdd.action.toString())
formData.append('approval_application_type_id', approvalApplicationAdd.approval_application_type_id.toString())
if(approvalApplicationAdd.approval_application_gate_id !== undefined) {
 formData.append('approval_application_gate_id', approvalApplicationAdd.approval_application_gate_id.toString())
 }
if(approvalApplicationAdd.approval1_user_id !== undefined) {
 formData.append('approval1_user_id', approvalApplicationAdd.approval1_user_id.toString())
 }
if(approvalApplicationAdd.approval2_user_id !== undefined) {
 formData.append('approval2_user_id', approvalApplicationAdd.approval2_user_id.toString())
 }
if(approvalApplicationAdd.content !== undefined) {
 formData.append('content', approvalApplicationAdd.content)
 }
if(approvalApplicationAdd['files[]'] !== undefined) {
 approvalApplicationAdd['files[]'].forEach(value => formData.append('files[]', value));
 }

    return axios.post(
      `/approvalApplications/add/${productionId}`,
      formData,options
    );
  }



    export type PostApprovalApplicationAddMutationResult = NonNullable<Awaited<ReturnType<typeof postApprovalApplicationAdd>>>
    export type PostApprovalApplicationAddMutationBody = ApprovalApplicationAdd
    export type PostApprovalApplicationAddMutationError = AxiosError<ErrorInfo>

    export const usePostApprovalApplicationAdd = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApprovalApplicationAdd>>, TError,{productionId: number;data: ApprovalApplicationAdd}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApprovalApplicationAdd>>, {productionId: number;data: ApprovalApplicationAdd}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postApprovalApplicationAdd(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postApprovalApplicationAdd>>, TError, {productionId: number;data: ApprovalApplicationAdd}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 以下の条件を両方とも満たすユーザーの一覧を取得する。  
・カレントユーザー（申請者）と同じ会社に所属している。  
・承認機能の権限を有している。

 * @summary 承認者の候補一覧取得
 */
export const getApprovalUsers = (
    productionId: number,
    params?: GetApprovalUsersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetApprovalUsers200>> => {
    return axios.get(
      `/approvalApplications/approvalUsers/${productionId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetApprovalUsersQueryKey = (productionId: number,
    params?: GetApprovalUsersParams,) => [`/approvalApplications/approvalUsers/${productionId}`, ...(params ? [params]: [])];

    
export type GetApprovalUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getApprovalUsers>>>
export type GetApprovalUsersQueryError = AxiosError<ErrorInfo>

export const useGetApprovalUsers = <TData = Awaited<ReturnType<typeof getApprovalUsers>>, TError = AxiosError<ErrorInfo>>(
 productionId: number,
    params?: GetApprovalUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApprovalUsers>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApprovalUsersQueryKey(productionId,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApprovalUsers>>> = ({ signal }) => getApprovalUsers(productionId,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getApprovalUsers>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 承認申請を更新する。

 * @summary 承認申請一件更新
 */
export const postApprovalApplicationUpdate = (
    approvalApplicationId: number,
    approvalApplicationUpdate: ApprovalApplicationUpdate, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ApprovalApplicationDetail>> => {const formData = new FormData();
formData.append('action', approvalApplicationUpdate.action.toString())
if(approvalApplicationUpdate.approval_application_gate_id !== undefined) {
 formData.append('approval_application_gate_id', approvalApplicationUpdate.approval_application_gate_id.toString())
 }
if(approvalApplicationUpdate.approval1_user_id !== undefined) {
 formData.append('approval1_user_id', approvalApplicationUpdate.approval1_user_id.toString())
 }
if(approvalApplicationUpdate.approval2_user_id !== undefined) {
 formData.append('approval2_user_id', approvalApplicationUpdate.approval2_user_id.toString())
 }
if(approvalApplicationUpdate.content !== undefined) {
 formData.append('content', approvalApplicationUpdate.content)
 }
if(approvalApplicationUpdate.file_ids !== undefined) {
 formData.append('file_ids', approvalApplicationUpdate.file_ids)
 }
if(approvalApplicationUpdate['files[]'] !== undefined) {
 approvalApplicationUpdate['files[]'].forEach(value => formData.append('files[]', value));
 }

    return axios.post(
      `/approvalApplications/update/${approvalApplicationId}`,
      formData,options
    );
  }



    export type PostApprovalApplicationUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof postApprovalApplicationUpdate>>>
    export type PostApprovalApplicationUpdateMutationBody = ApprovalApplicationUpdate
    export type PostApprovalApplicationUpdateMutationError = AxiosError<ErrorInfo>

    export const usePostApprovalApplicationUpdate = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApprovalApplicationUpdate>>, TError,{approvalApplicationId: number;data: ApprovalApplicationUpdate}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApprovalApplicationUpdate>>, {approvalApplicationId: number;data: ApprovalApplicationUpdate}> = (props) => {
          const {approvalApplicationId,data} = props ?? {};

          return  postApprovalApplicationUpdate(approvalApplicationId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postApprovalApplicationUpdate>>, TError, {approvalApplicationId: number;data: ApprovalApplicationUpdate}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 承認申請を一件削除する。

 * @summary 承認申請一件削除
 */
export const postApprovalApplicationDelete = (
    approvalApplicationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/approvalApplications/delete/${approvalApplicationId}`,undefined,options
    );
  }



    export type PostApprovalApplicationDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postApprovalApplicationDelete>>>
    
    export type PostApprovalApplicationDeleteMutationError = AxiosError<ErrorInfo>

    export const usePostApprovalApplicationDelete = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApprovalApplicationDelete>>, TError,{approvalApplicationId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApprovalApplicationDelete>>, {approvalApplicationId: number}> = (props) => {
          const {approvalApplicationId} = props ?? {};

          return  postApprovalApplicationDelete(approvalApplicationId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postApprovalApplicationDelete>>, TError, {approvalApplicationId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 日程に基づく承認申請を作成する。

 * @summary 日程に基づく承認申請作成(テスト用)
 */
export const postApprovalApplicationAddBasedOnSchedule = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/approvalApplications/addBasedOnSchedule/${productionId}`,undefined,options
    );
  }



    export type PostApprovalApplicationAddBasedOnScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof postApprovalApplicationAddBasedOnSchedule>>>
    
    export type PostApprovalApplicationAddBasedOnScheduleMutationError = AxiosError<ErrorInfo>

    export const usePostApprovalApplicationAddBasedOnSchedule = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApprovalApplicationAddBasedOnSchedule>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApprovalApplicationAddBasedOnSchedule>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postApprovalApplicationAddBasedOnSchedule(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postApprovalApplicationAddBasedOnSchedule>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    